import { Tabs } from 'antd'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import BackgroundBox from '../../components/custom_components/BackgroundBox'
import { ContentContainer } from '../../components/custom_components/ContentContainer'
import { NewLoadingAndErrors } from '../../components/custom_components/LoadingAndErrors/NewLoadingAndErrors'
import { PerProfileHeader } from '../../components/custom_components/Profile/ProfileHeader'
import { useAuth } from '../../context/auth-context'
import useMyPrivateProfile from '../../graphql/profiles/useMyPrivateProfile'
import { useCollapse } from '../../routes/collapse-context'
import { PrivateContractTab } from './tabs/PrivateContractTab'
import { PrivatePersonalDataTab } from './tabs/PrivatePersonalDataTab'

const { TabPane } = Tabs

export const PrivateProfilePage: FC = () => {
  const { user } = useAuth()
  const [activeKey, setActiveKey] = useState('privateProfile-tab-1')
  const collapsed = useCollapse()

  const { data, error, loading } = useMyPrivateProfile(user.employeeId)
  const { t } = useTranslation()

  if (loading || error || !data || !data.personalProfile) {
    return (
      <ContentContainer collapsed={collapsed}>
        <BackgroundBox r height="fullPage">
          <NewLoadingAndErrors isLoading={loading} error={error} hasNoData={!data || !data.personalProfile} showSpinner t={t} />
        </BackgroundBox>
      </ContentContainer>
    )
  }

  return (
    <ContentContainer collapsed={collapsed}>
      <div data-e2e-my-profile-page>
        <Tabs
          activeKey={activeKey}
          renderTabBar={() => (
            <PerProfileHeader profile={data.personalProfile}>
              <Tabs onChange={(key) => setActiveKey(key)}>
                <TabPane tab={t('profile.tabs.personalData')} key="privateProfile-tab-1" data-e2e-my-profile-tab="personaldata" />
                <TabPane tab={t('profile.tabs.employment')} key="privateProfile-tab-2" data-e2e-my-profile-tab="contract" />
              </Tabs>
            </PerProfileHeader>
          )}
        >
          <TabPane key="privateProfile-tab-1">
            <BackgroundBox r height="profileView">
              <PrivatePersonalDataTab profile={data.personalProfile} />
            </BackgroundBox>
          </TabPane>

          <TabPane key="privateProfile-tab-2">
            <BackgroundBox r height="profileView">
              <PrivateContractTab profile={data.personalProfile} />
            </BackgroundBox>
          </TabPane>
        </Tabs>
      </div>
    </ContentContainer>
  )
}
